module.exports = __webpack_public_path__ + "img/kjpz.9a1f975b.svg";